import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl } from '@angular/forms';
import validator from 'validator';

@Injectable({
    providedIn: 'root'
})

export class BasicService{
    user_data:any={}
    cssTheme: BehaviorSubject<string>;
    countryCode="+91"
    appName="InvoiceSacn"
    showprogress=false;
    current_year=new Date().getFullYear()

    defaultTallyFields=[
        "ItemName",
        "Qty",
        "Rate",
        "Total"
    ]

    

    constructor(){
        this.cssTheme = new BehaviorSubject('light-theme');
    }

    setItem(key:any,data:any){
        localStorage.setItem(this.appName+key,JSON.stringify(data))
    }
    getItem(key:any){
        let data:any=localStorage.getItem(this.appName+key)
        return JSON.parse(data)
    }

    setTheme(theme: string){
        this.cssTheme.next(theme);
    }

    private controlText(control: AbstractControl): string {
        const value = control.value;
        if (value === null || value === undefined) {
            return '';
        }
        return String(value).trim();
    }

    isEmail=(control: AbstractControl): { [key: string]: boolean } | null =>{
        const value = this.controlText(control);
        if(value && !validator.isEmail(value)){
            return { 'emailValid': true };
        }
        return null;
    }
    isPhone=(control: AbstractControl): { [key: string]: boolean } | null =>{
        const value = this.controlText(control);
        console.log(this.countryCode+value)
        if(value && !validator.isMobilePhone(this.countryCode+value,"en-IN")){
            console.log(validator.isMobilePhone(this.countryCode+value,"any"))
            return { 'phoneValid': true };
        }
        return null;
    }
    isEmpty=(control: AbstractControl): { [key: string]: boolean } | null =>{
        const value = this.controlText(control);
        if(control.value !== null && control.value !== undefined && control.value !== '' && value === ''){
            return { 'emptyValid': true };
        }
        return null;
    }

    normalize_char_value=(value:any)=>{
        // console.log(value)
        value=value.replace("¥","") 
        value=value.replace("-","")
        let valueArr=value.split(",")
        valueArr.reverse()
        // console.log(valueArr)
        let tempValue=""
        for(let i=0;i<valueArr.length;i++){
            if (valueArr[i].length==2 && i==0){
                tempValue="."+valueArr[i]
            }else{
                tempValue=valueArr[i]+tempValue
            }
        }
        return this.normalize_value(tempValue) 
    }
    normalize_value(value:any){
        
        if(value.match(/%/gi)){
            return 0
        }
        let valueArr=value.split('');
        let tempValue=""
        for(let i=0;i<valueArr.length;i++){
            if (valueArr[i]=='.' || !Number.isNaN(Number(valueArr[i]))){
                tempValue+=valueArr[i]
                // console.log(tempValue)
            }
        }
        return tempValue
    }
           
}